import React from 'react';
import Snackbar from 'Snackbar';
import Grid from '@material-ui/core/Grid';
import DonutLarge from '@material-ui/icons/DonutLarge';
import styled from 'styled-components';
import DashboardCard from './components/DashboardCard';
import { getAdminDashboardData } from 'Actions/adminActions';
import connect from 'react-redux/es/connect/connect';
import Button from '@material-ui/core/Button';
import axios from 'Axios';
import Loader from 'Components/Loader';
import SendMessageToUsers from './components/SendMessageToUsersDialog';
import RequestDbData from './components/RequestDbData';
import QuotationsDialog from './components/QuotationsDialog';
import OpenLogsDialog from './components/OpenLogsDialog';

const NoTicketsDashboard = styled.div`
  display: flex;
  align-content: center;
`;
const NoTicketsH2 = styled.h2`
  font-weight: bold;
  margin: 0 0 5px 0;
`;
const DonutLargeCustom = styled(DonutLarge)`
  font-size: 50px;
  width: 40px;
  height: 40px;
  color: #999a9a;
  margin-right: 20px;
`;
const NoTicketsP = styled.p`
  font-family: Times, 'Times New Roman', Times32;
  font-size: 12px;
  line-height: 13px;
  margin: 0;
  color: #62727b;
`;

const DownloadButton = styled(Button)`
  background: #fff !important;
  margin-right: 16px !important;
`;

const lineColors = [
  '#ffca28',
  '#62727b',
  '#c79a00',
  '#999a9a',
  '#F44336',
  '#37474f',
  '#37994f',
];

class HomeDashboard extends React.Component {
  state = {
    tabValue: 0,
    newProjectDialogOpen: false,
    hasProjects: true,
    downloading: false,
    downloadingLogs: false,
    downloadingQuotations: false,
    sending: false,
    openMessageDialog: false,
    openRequestDbDataDialog: false,
    openLogsDialog: false,
    isOpenQuotationModal: false,
    message: '',
    mailForDB: '',
    mailTo: 'ALL',
    quotationsEmail: '',
    openSnackbar: false,
    msg: '',
  };

  componentDidMount() {
    this.props.getDashboardData();
  }

  closeMessageDialog = () => {
    this.setState({
      sending: false,
      openMessageDialog: false,
      message: '',
      mailTo: 'ALL',
    });
  };

  closeRequestDbDataDialog = () => {
    this.setState({
      downloading: false,
      openRequestDbDataDialog: false,
    });
  };

  closeLogsDialog = () => {
    this.setState({
      downloadingLogs: false,
      openLogsDialog: false,
    });
  };

  closeQuotationDialog = () => {
    this.setState({
      isOpenQuotationModal: false,
      downloadingQuotations: false,
    });
  };

  openMessageDialog = () => {
    this.setState({ openMessageDialog: true });
  };

  openLogsDialog = () => {
    this.setState({ openLogsDialog: true });
  };

  openQuotationDialog = () => {
    this.setState({ isOpenQuotationModal: true });
  };

  openRequestDbDataDialog = () => {
    this.setState({ openRequestDbDataDialog: true });
  };

  sendMailTo = event => {
    this.setState({ mailTo: event.target.value });
  };

  setMessage = event => {
    this.setState({ message: event.target.value });
  };

  setSendOnMail = event => {
    this.setState({ mailForDB: event.target.value });
  };

  setSendOnMailQuotations = event => {
    this.setState({ quotationsEmail: event.target.value });
  };

  handleCloseSncakbar = () => {
    this.setState({ openSnackbar: false, msg: '' });
  };

  downloadQuotations = () => {
    this.setState({ downloadQuotations: true, downloadingQuotations: true });

    axios
      .post('admin/export_quotations', { email: this.state.quotationsEmail })
      .then(response => {
        if (response.status === 200) {
          this.setState({
            openSnackbar: true,
            msg: 'The request for quotations data has been sent',
          });

          this.closeQuotationDialog();
        }
      })
      .catch(error => {
        console.log(error.message);
      })
      .finally(() => {
        this.setState({ downloadingQuotations: false });
      });
  };

  downloadSpecSheet = exportType => {
    this.setState({ downloading: true });

    axios
      .post(`admin/export_db/${exportType}`, { email: this.state.mailForDB })
      .then(
        response => {
          if (response.status === 200) {
            this.setState({
              downloading: false,
              openSnackbar: true,
              msg: 'The request for exporting database data has been sent',
            });
            this.closeRequestDbDataDialog();
          }
        },
        error => {
          this.setState({ downloading: false });
          if (error) {
            this.setState({
              openSnackbar: true,
              msg: 'Something went wrong, try again later',
            });
          }
        }
      );
  };

  downloadLogs = () => {
    this.setState({ downloadingLogs: true });

    axios.post('/recent-logs', { email: this.state.mailForDB }).then(
      response => {
        if (response.status === 200) {
          this.setState({
            downloadingLogs: false,
            openSnackbar: true,
            msg: 'The request for logs data has been sent',
          });
          this.closeLogsDialog();
        }
      },
      error => {
        this.setState({ downloadingLogs: false });
        if (error) {
          this.setState({
            openSnackbar: true,
            msg: 'Something went wrong, try again later',
          });
        }
      }
    );
  };

  sendEmail = () => {
    this.setState({ sending: true });
    const data = { body: this.state.message, type: this.state.mailTo };

    axios({
      url: 'admin/email_all',
      method: 'POST',
      data,
    }).then(
      response => {
        this.setState({ sending: false });
        this.closeMessageDialog();
      },
      error => {
        this.setState({ sending: false });
      }
    );
  };

  renderDashboard = () => {
    if (this.props.dashboardData && this.props.dashboardData.length > 0) {
      return (
        <Grid
          container
          className="tickets-dashboard"
          alignItems={'center'}
          justify={'flex-start'}
          spacing={16}
        >
          <Grid item xs={12}>
            <DownloadButton
              variant="contained"
              className="t-weight-b criteria-button "
              onClick={this.openRequestDbDataDialog}
            >
              <React.Fragment>
                <Loader isLoading={this.state.downloading} size={32} />
                <p
                  style={{
                    visibility: this.state.downloading ? 'hidden' : 'visible',
                  }}
                >
                  Download Data
                </p>
              </React.Fragment>
            </DownloadButton>
            <DownloadButton
              variant="contained"
              className="t-weight-b criteria-button"
              onClick={this.openMessageDialog}
            >
              Send message to users
            </DownloadButton>
            <DownloadButton
              variant="contained"
              className="t-weight-b criteria-button"
              onClick={this.openLogsDialog}
            >
              Download logs
            </DownloadButton>
            <DownloadButton
              variant="contained"
              className="t-weight-b criteria-button"
              onClick={this.openQuotationDialog}
            >
              Download Quotations
            </DownloadButton>
          </Grid>
          {this.props.dashboardData.map((dashboardItem, index) => (
            <Grid item xl={3} lg={4} md={6} xs={12} key={dashboardItem.key}>
              <DashboardCard
                title={dashboardItem.title}
                count={dashboardItem.count}
                color={lineColors[index] ? lineColors[index] : '#fff'}
              />
            </Grid>
          ))}
        </Grid>
      );
    } else {
      return (
        <NoTicketsDashboard>
          <DonutLargeCustom />
          <div>
            <NoTicketsH2>Not enough data for statistic</NoTicketsH2>
            <NoTicketsP>
              0 New Luminaires, 0 Updated Luminaires, 0 Luminaires in total, 0
              Searches and 0 Items in 0 Projects
            </NoTicketsP>
          </div>
        </NoTicketsDashboard>
      );
    }
  };

  render() {
    return (
      // Page with tickets
      <React.Fragment>
        {this.renderDashboard()}
        <SendMessageToUsers
          open={this.state.openMessageDialog}
          closeMessageDialog={this.closeMessageDialog}
          sendEmail={this.sendEmail}
          sendMailTo={this.sendMailTo}
          message={this.state.message}
          mailTo={this.state.mailTo}
          setMessage={this.setMessage}
          sending={this.state.sending}
        ></SendMessageToUsers>
        <RequestDbData
          open={this.state.openRequestDbDataDialog}
          closeMessageDialog={this.closeRequestDbDataDialog}
          sendOnMail={this.state.mailForDB}
          setSendOnMail={this.setSendOnMail}
          sending={this.state.downloading}
          downloadSpecSheet={this.downloadSpecSheet}
        ></RequestDbData>
        <OpenLogsDialog
          open={this.state.openLogsDialog}
          closeLogsDialog={this.closeLogsDialog}
          sendOnMail={this.state.mailForDB}
          setSendOnMail={this.setSendOnMail}
          sending={this.state.downloadingLogs}
          downloadLogs={this.downloadLogs}
        ></OpenLogsDialog>
        <QuotationsDialog
          open={this.state.isOpenQuotationModal}
          closeMessageDialog={this.closeQuotationDialog}
          sendOnMail={this.state.quotationsEmail}
          setSendOnMail={this.setSendOnMailQuotations}
          sending={this.state.downloadingQuotations}
          onDownload={this.downloadQuotations}
        />
        <Snackbar
          open={this.state.openSnackbar}
          msg={this.state.msg}
          onClose={this.handleCloseSncakbar}
        />
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getDashboardData: () => {
    dispatch(getAdminDashboardData());
  },
});
const mapStateToProps = store => {
  return {
    dashboardData: store.adminData.dashboardData,
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(HomeDashboard);
